<script setup>
const emit = defineEmits(['addressAutocomplete'])

defineProps({
  idPrefix: {
    type: String,
    required: true,
  },
  stateOptions: {
    type: Object,
    required: true,
  },
})
</script>
<template>
  <div>
    <div class="row">
      <div class="columns small-12 first-address">
        <div class="floating">
          <MapsAutocompleteAddressInputFK
            :id="`${idPrefix}-payment-address-line-1`"
            name="billing1"
            validation="required"
            placeholder="Address (We cannot ship to P.O. boxes)"
            label="Address (We cannot ship to P.O. boxes)"
            :validation-messages="{
              required: 'Error: Address is required.',
            }"
            @onAddressSelected="emit('addressAutocomplete', $event)"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="columns small-12 second-address">
        <div class="floating">
          <FloatingInputFK
            :id="`${idPrefix}-payment-address-line-2`"
            name="billing2"
            placeholder="Apt, suite, etc (Optional)"
            label="Apt, suite, etc (Optional)"
          />
        </div>
      </div>
    </div>
    <div class="row third-address">
      <div class="columns medium-4">
        <div class="floating no-margin-medium-up">
          <FloatingInputFK
            :id="`${idPrefix}-payment-city`"
            name="city"
            validation="required"
            placeholder="City"
            label="City"
          />
        </div>
      </div>
      <div class="columns medium-4">
        <div class="floating no-margin-medium-up">
          <FloatingInputFK
            :id="`${idPrefix}-payment-state`"
            type="select"
            input-class="floating__select"
            :options="stateOptions"
            name="state"
            validation="required"
            placeholder=" "
            label="State"
          />
        </div>
      </div>
      <div class="columns medium-4">
        <div class="floating no-margin">
          <FloatingInputFK
            :id="`${idPrefix}-postcode`"
            name="zipcode"
            validation="bail|required|matches:/^\d{5}(?:-\d{4})?$/"
            placeholder="Zip/Postal Code"
            label="Zip/Postal Code"
            :validation-messages="{
              matches: 'Error: You must input a valid US Zip Code',
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>
